@import '@hevoio/hevo-ui-toolkit/styles/variables';

.iconFrame {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: $spacer-36;
  height: $spacer-36;
  border: $border-width solid $default-border;
  border-radius: 50%;

  // Toolkit MenuItem gives every descendant icon a 12px right margin for the
  // icon-then-label items it was written for. Inside this frame that margin is
  // part of the centred flex item, so it shoves the glyph left of centre.
  //
  // `!important` is measured, not defensive: MUI styles MenuItem through
  // emotion, so the rule is `.css-hash.MuiMenuItem-root .hevo-icon` — (0,3,0).
  // A CSS-module descendant selector reaches only (0,2,0) and silently loses,
  // and emotion's injection order makes a (0,3,0) tie a coin flip.
  :global(.hevo-icon),
  svg {
    margin-right: 0 !important;
  }
}
